import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { ServiceConfig } from "../../core/core.constants";
import { Injector } from '@angular/core';
import { AuthServerProvider } from '../../shared/auth/auth.service';
import { catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { Auth401Service } from '../../shared/auth/auth401.service';

export class AuthInterceptor implements HttpInterceptor {
    constructor(private injector: Injector) { }

    private get authServerProvider(): AuthServerProvider {
        return this.injector.get(AuthServerProvider);
    }

    private get auth401Service(): Auth401Service {
        return this.injector.get(Auth401Service);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request || !request.url || (/^http/.test(request.url) && !(ServiceConfig.webApiUrl && request.url.startsWith(ServiceConfig.webApiUrl)))) {
            return next.handle(request);
        }

        const jwtToken = this.authServerProvider.getToken();
        if (!!jwtToken) {
            request = this.addJwtToken(request, jwtToken);
        }

        return next.handle(request).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                return this.auth401Service.handle401Error(newJwtToken => next.handle(this.addJwtToken(request, newJwtToken)), error, !!jwtToken, () => jwtToken);
            } else {
                return _throw(error);
            }
        }));
    }

    private addJwtToken(request: HttpRequest<any>, jwtToken: string) {
        return request.clone({
            setHeaders: {
                Authorization: 'Bearer ' + jwtToken
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/blocks/interceptor/auth.interceptor.ts